import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=6db6f465&scoped=true&"
import script from "./payment-methods.vue?vue&type=script&lang=ts&"
export * from "./payment-methods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6f465",
  null
  
)

export default component.exports